module.exports = __webpack_public_path__ + "img/los-cabos-arco.5184f7fc.jpg";